import { Constants } from '..';
export class SubmittalCommonUtils {
    static getRevisionStateHistory(revision) {
        return revision?.status_history || [];
    }
    static getLatestRevision(submittal) {
        if (!submittal.revisions || submittal.revisions.length === 0)
            return null;
        return submittal.revisions[submittal.revisions.length - 1];
    }
    static isApproved(submittal) {
        const latestRevision = SubmittalCommonUtils.getLatestRevision(submittal);
        if (!latestRevision) {
            return false;
        }
        const statusHistory = SubmittalCommonUtils.getRevisionStateHistory(latestRevision);
        const lastStatus = statusHistory[statusHistory.length - 1];
        return lastStatus?.state_id === Constants.SUBMITTAL_APPROVAL_STATUS_ID;
    }
}
